module.exports = __webpack_public_path__ + "static/media/thumbnail.1cc9df8c.jpg";